import {FC} from "react";
import adminApi from "api/admin";
import {IBooksmatchStats} from "api/types";
import {useQuery} from "@tanstack/react-query";
import FullpageLoader from "components/loaders/FullpageLoader";
import useAwaitableModal from "hooks/useAwaitableModal";
import UsersByCreatedDate from "./modals/UsersByCreatedDate";

const BooksmatchStatsPage: FC = () => {
  const {data: stats} = useQuery<IBooksmatchStats>({
    queryKey: ["stats"],
    queryFn: () => adminApi.getStats(),
  });

  const [openRecuiters, RecruitersModal] = useAwaitableModal(UsersByCreatedDate, {
    title: "Recruiters",
    profiles: stats?.recruitersSummary || [],
  });

  const onRecruiters = () => {
    openRecuiters({
      title: "Recruiters",
      profiles: stats?.recruitersSummary || [],
    }).then(() => {});
  };

  if (!stats) return <FullpageLoader />;

  const rows: {label: string; value: React.ReactNode}[] = [
    {label: "Total Users", value: stats.nUsers},
    {label: "Accountants", value: stats.nAccountants},
    {label: "Gym Members", value: stats.talents},
    {label: "Talents Open To Work", value: stats.visibleAccountants},
    {
      label: "Recruiters",
      value: (
        <span className="text-brand-amber cursor-pointer hover:underline" onClick={onRecruiters}>
          {stats.nRecruiters}
        </span>
      ),
    },
    {label: "Watched", value: stats.watched},
    {label: "Conversations Started", value: stats.nChats},
    {label: "Messages Sent", value: stats.messages},
  ];

  return (
    <div className="w-full h-full">
      {RecruitersModal}
      <div className="pt-8 px-8 gap-8 flex-cool h-full">
        <div className="gap-4 flex items-center mobile:flex-col mobile:gap-4">
          <span className="font-semibold text-3xl text-brand-navy">Booksmatch Stats</span>
          <button
            onClick={() =>
              window.open(
                // eslint-disable-next-line max-len
                "https://console.firebase.google.com/project/booksmatch-f6ac0/analytics/app/web:N2IyMGMyNDUtOWE1NC00MGNjLWE3NmMtYmYzMGI5MzY0NjUx/overview",
                "_blank",
              )
            }
            className="btn-primary"
          >
            Firebase Analytics
          </button>
        </div>
        <div className="flex-cool min-h-min grow bg-white rounded-2xl divide-y divide-brand-border overflow-hidden overflow-y-auto">
          {rows.map(({label, value}) => (
            <div key={label} className="flex items-center px-8 py-5 gap-6">
              <span className="text-brand-muted text-sm grow">{label}</span>
              <span className="text-brand-navy text-sm font-medium">{value}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BooksmatchStatsPage;
